__turbopack_context__.v({
  "logo": "_5UT8_G_logo",
  "responsiveGrid": "_5UT8_G_responsiveGrid",
});
